import { render } from "./PolygonSelectionWizard.vue?vue&type=template&id=22157240&scoped=true"
import script from "./PolygonSelectionWizard.vue?vue&type=script&lang=js"
export * from "./PolygonSelectionWizard.vue?vue&type=script&lang=js"

import "./PolygonSelectionWizard.vue?vue&type=style&index=0&id=22157240&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22157240"]])

export default __exports__